// hook copied from CUI https://gitlab.com/chegginc/learning-services/devx/ui/components/-/blob/main/packages/Toggletip/src/shared.ts
// currently not exported
/* The CUI hook was modified accordingly:
 (1) it now accepts an optional onToggle prop (e.g. to change styling on trigger element when toggletip closed)
 (2) triggering an open toggletip closes it
 (3) hardcoded onKeyDown behavior is removed, letting the provided targetElement determine which keypresses trigger 
*/
import { ToggletipBehavior } from '@chegg-ui/toggletip'
import {
  isKeyboardEvent,
  RealOrSyntheticEvent,
  tabbingOutsideOfElement,
} from '@chegg-ui/utils'
import React, { cloneElement, useEffect, useRef, useState } from 'react'

export function useToggletipBehavior(
  targetElement: React.ReactElement,
  onToggle?: (...args: any[]) => any
): ToggletipBehavior {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const [isToggletipShown, setIsToggletipShown] = useState(false)
  const givenOnToggle = () => (onToggle ? onToggle() : null)
  // event can either be a React synthetic event (from user interaction) or a "real" event (from the onclick listeners)
  const hideToggletip = (e: RealOrSyntheticEvent): void => {
    if (isKeyboardEvent(e)) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        setIsToggletipShown(false)
        givenOnToggle()
      }
      if (wrapperRef.current && tabbingOutsideOfElement(e, wrapperRef.current)) {
        setIsToggletipShown(false)
        givenOnToggle()
      }
    } else {
      setIsToggletipShown(false)
      givenOnToggle()
    }
  }
  const showToggletip = (): void => {
    if (isToggletipShown) {
      // we set a timeout to make sure the content goes away and comes back (for live region behavior)
      setTimeout(() => {
        setIsToggletipShown(true)
        givenOnToggle()
      }, 0)
    } else {
      setIsToggletipShown(true)
      givenOnToggle()
    }
  }
  useEffect(() => {
    if (isToggletipShown) {
      document.addEventListener('click', hideToggletip)
      document.addEventListener('keydown', hideToggletip)
    }
    return () => {
      document.removeEventListener('click', hideToggletip)
      document.removeEventListener('keydown', hideToggletip)
    }
  }, [isToggletipShown])
  const givenOnClick = targetElement.props.onClick
  const givenOnKeyDown = targetElement.props.onKeyDown

  const extendedTargetElement = cloneElement(targetElement, {
    onClick: (e: React.MouseEvent) => {
      if (givenOnClick) {
        givenOnClick(e)
      }
      if (!isToggletipShown) {
        showToggletip()
      }
    },
    onKeyDown: (e: React.KeyboardEvent) => {
      if (givenOnKeyDown) {
        givenOnKeyDown(e)
      }
    },
    ['aria-expanded']: isToggletipShown,
  })
  return {
    isToggletipShown,
    extendedTargetElement,
    wrapperRef,
  } as ToggletipBehavior
}



// WEBPACK FOOTER //
// ./src/utils/hooks/useToggletipBehavior.ts